import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const style = document.createElement('style');
style.textContent = `
  * { margin: 0; padding: 0; box-sizing: border-box; }
  body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    background: #f1f5f9; color: #0f172a;
    -webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
  }
  input:focus { outline: none; border-color: #3b82f6 !important; }
  button { transition: opacity .12s ease, background .12s ease, transform .08s ease; }
  button:hover:not(:disabled) { opacity: 0.92; }
  button:active:not(:disabled) { transform: translateY(1px); }
  button:disabled { opacity: 0.6; cursor: not-allowed; }
  /* Scrollbar fino y discreto */
  ::-webkit-scrollbar { width: 10px; height: 10px; }
  ::-webkit-scrollbar-track { background: transparent; }
  ::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 8px; border: 2px solid transparent; background-clip: content-box; }
  ::-webkit-scrollbar-thumb:hover { background: #94a3b8; background-clip: content-box; }
  /* Sidebar (fondo oscuro) scrollbar más tenue */
  aside::-webkit-scrollbar-thumb { background: rgba(148,163,184,.35); background-clip: content-box; }
  @keyframes spin { to { transform: rotate(360deg); } }
  .spin { animation: spin 1s linear infinite; }
  img { max-width: 100%; }
`;
document.head.appendChild(style);

ReactDOM.createRoot(document.getElementById('root')).render(<React.StrictMode><App /></React.StrictMode>);
